class Accordion {
  constructor($el) {
    this.$container   = $el;
    this.$btn         = this.$container.find('.js-toggle-accordion');
    this.$crop        = this.$container.find('.js-accordion-crop');
    this.$heightBase  = this.$crop.children();
    this.isOpen       = false;
    setTimeout(() => {
      this.$crop.css('display', 'none');
    }, 500);

    this.$btn.on('click', () => {
      if(this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    });
  }

  open() {
    if(!this.isOpen) {
      this.isOpen = true;
      this.$container.addClass('-open');
      this.$crop.attr('aria-hidden', 'false');
      this.$crop.stop(false).css({'display': 'block'});
      let targetHeight = this.$heightBase.outerHeight();
      this.$crop.stop(false).animate({'height': targetHeight}, 900, 'easeInOutSine', () => {
        this.$crop.css({'height': 'auto', 'overflow': 'auto'});
      });
    }
  }
  close() {
    if(this.isOpen) {
      this.isOpen = false;
      this.$container.removeClass('-open');
      this.$crop.attr('aria-hidden', 'true');
      this.$crop.stop(false).css({'height': this.$heightBase.outerHeight(), 'overflow':'hidden'})
        .delay(30).animate({'height': 0}, 400, 'easeOutSine', () => {
          this.$crop.css('display', 'none');
        });
    }
  }
}

export default Accordion;
